export interface DatesInput {
    date: string;
    selected: boolean;
}

export interface Company {
    code: string;
    name: string;
    typeId: number;
}

export interface BreadcrumbItem {
    label: string;
    route?: string;
    active?: boolean;
}

export enum FileType {
    Ret = 1,
    Rem = 2,
}

export enum AutomaticDebitFileRetStatus {
    Efetuado = 0,
    InsuficienciaFundos = 1,
    ContaCorrenteNaoCadastrada = 2,
    OutrasRestricoes = 4,
    ValorExcedeLimite = 5,
    AgenciaEncerrada = 10,
    ValorInvalido = 12,
    DataLancamentoInvalida = 13,
    AgenciaInvalida = 14,
    ContaCorrenteInvalida = 15,
    DataDebitoAnterior = 18,
    SemContratoDebitoAutomatico = 30,
    DataDiferentePorFeriado = 31,
    ManutencaoCadastro = 96,
    CancelamentoNaoEncontrado = 97,
    CancelamentoForaTempoHabil = 98,
    CancelamentoSolicitacao = 99,
    BoletoNaoLocalizado = 404,
}
